import React from 'react';
import Span from '../../Texts/Span/Span';
import Pill from '../../Pill/Pill';
import Tooltip from '../../Tooltip/Tooltip';
import * as S from './IdNumberFormatter.styles';

export const IdNumberFormatter = ({
  cell,
  row,
  formatExtraData: { pad, showPill, pill, showTooltip, tooltip },
}) => {
  const renderCell = () => {
    return (
      <S.ItemWrapper leftSpacing='spacing-0'>
        <Span variant='neutral' modifier='strong' type='4'>
          {pad
            ? cell.toString().padStart(pad.targetLength, pad.padString)
            : cell}
        </Span>
      </S.ItemWrapper>
    );
  };

  const renderPill = () => {
    if ((pill?.flagName && row[pill?.flagName]) || showPill) {
      return (
        <S.ItemWrapper leftSpacing='spacing-6'>
          <Pill variant={pill.variant}>{pill?.text}</Pill>
        </S.ItemWrapper>
      );
    }
  };

  const renderTooltip = () => {
    if ((tooltip?.flagName && row[tooltip?.flagName]) || showTooltip) {
      return (
        <S.ItemWrapper leftSpacing='spacing-3'>
          <Tooltip msg={tooltip.msg} position={tooltip.position}>
            {tooltip.children}
          </Tooltip>
        </S.ItemWrapper>
      );
    }
  };

  return cell || cell === 0 ? (
    <S.CellWrapper>
      {renderCell()}
      {renderPill()}
      {renderTooltip()}
    </S.CellWrapper>
  ) : null;
};
